<template>
  <ListButton content-class="account_card" min-width="200">
    <template #activator="{ menu }">
      <v-flex v-on="menu" class="badge-center">
        <v-tooltip bottom>
          <template #activator="{ on: tip }">
            <a v-on="tip" style="width: 50px" class="text-center">
              <IconButton color="#fff">settings</IconButton>
            </a>
          </template>
          <span>設定</span>
        </v-tooltip>
      </v-flex>
    </template>
    <template #list-menu>
      <v-btn flat class="no-mpr h-100 ma-0 w-100" style="text-transform: none" @click="openUserSettings">
        <SpanText class="mt-2 mb-2">ユーザー管理</SpanText>
      </v-btn>
      <v-btn flat v-if="isUserGroupUsable" class="no-mpr h-100 ma-0 w-100" style="text-transform: none" @click="openUserGroupSettings">
        <SpanText class="mt-2 mb-2">アクセス権限管理</SpanText>
      </v-btn>
      <v-btn
        v-if="hasCompanyPrioritySettingsPermission"
        flat
        class="no-mpr h-100 ma-0 w-100"
        style="text-transform: none"
        @click="movePrioritySettings"
      >
        <SpanText class="mt-2 mb-2">優先度設定</SpanText>
      </v-btn>
    </template>
  </ListButton>
</template>
<script>
import Button from '@/components/_atoms/buttons/Button.vue';
import IconButton from '@/components/_atoms/buttons/IconButton';
import SpanText from '@/components/_atoms/SpanText.vue';
import ListButton from '@/components/_molecules/buttons/ListButton.vue';

import path from '../../constants/path';

export default {
  name: 'UserSettingsMenu',
  components: { Button, IconButton, SpanText, ListButton },
  props: {
    color: {
      type: String,
      required: false,
      default: 'white'
    }
  },
  computed: {
    hasCompanyPrioritySettingsPermission() {
      return this.$store.state.auth.company.companyContracts.companyPrioritySettings;
    },
    isUserGroupUsable() {
      return this.$store.getters['auth/isUserGroupUsable'];
    }
  },
  methods: {
    openUserSettings() {
      window.open(window.location.origin + path.userSettings, 'UserSettings');
    },
    openUserGroupSettings() {
      window.open(window.location.origin + path.userSettings + '?settings_mode=1', 'UserSettings');
    },
    movePrioritySettings() {
      this.$router.push({ name: 'PrioritySettings' });
    }
  }
};
</script>

<style scoped>
.badge-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_organisms/UserSettingsMenu.vue